import { Button } from '@flowus/common/components';
import { message } from '@flowus/common/components/message';
import { cx } from '@flowus/common/cx';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { useOpenModal } from '@flowus/common/next-modal';
import type { FC } from 'react';
import { request } from 'src/common/request';

interface Props {
  className?: string;
  uuid: string;
}
export const PublishButton: FC<Props> = (props) => {
  const { className, uuid } = props;
  const { t } = useAppTranslation();
  const openModal = useOpenModal();

  const onPublish = async () => {
    const id = message.loading(t('share.publish.pushing'));
    await request.infra.subscribePublishChange(uuid);
    message.closeMessage(id);
    message.success(t('share.publish.success'));
  };

  const handleClick = () => {
    openModal.warning({
      title: t('share.publish.confirm_title'),
      confirmText: t('share.publish.confirm_button'),
      confirm: onPublish,
    });
  };

  if (__PRIVATE__) return null;

  return (
    <Button className={cx('flex-shrink-0', className)} onClick={handleClick}>
      {t('common.publish')}
    </Button>
  );
};
